import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'core/root';

import 'styles/main.css';

const element = document.getElementById('root');

ReactDOM.render(<Root/>, element);

/* HMR opt-in setting for this module */
if(module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/core/main.js